import React from 'react';
import { Tag } from 'antd';
import { capitalize } from '@shared/utils/string';
import {
	AccountingItemApprovalStates,
	HireInvoiceItemStates,
} from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';

type StateTypes = (
	Values<typeof AccountingItemApprovalStates> |
	Values<typeof HireInvoiceItemStates> |
	string |
	'estimated'
);

const getStateColor = (
	state: StateTypes,
) => {
	switch (state) {
		case 'estimated':
			return 'cyan';
		case HireInvoiceItemStates.PAID:
			return 'green';
		case HireInvoiceItemStates.PENDING:
			return 'orange';

		case HireInvoiceItemStates.INVOICED:
			return 'purple';

		case HireInvoiceItemStates.UNRESOLVED:
			return 'red';

		case HireInvoiceItemStates.PARTIAL:
			return 'cyan';

		case HireInvoiceItemStates.OVERPAID:
			return 'red';

		default:
			return 'grey';
	}
};

const StateTag = ({
	state,
	showUnresolved = true,
	className,
}: {
	state: StateTypes; showUnresolved?:boolean;
	className?: string;
}) => {
	const formattedState = state === HireInvoiceItemStates.UNRESOLVED && !showUnresolved ?
		HireInvoiceItemStates.INVOICED : state;

	return (
		<Tag className={className} color={getStateColor(formattedState)}>
			{capitalize(formattedState)}
		</Tag>
	);
};

export default StateTag;
